import styled from 'styled-components';
import { Button, Checkbox, Select, Text } from '@rsos/base-components';
import Box from '@rsos/components/capstone/base/Box';

export const StyledButtonBox = styled(Box).attrs({
  flow: 16,
  horizontal: true,
  justify: 'flex-end',
  mt: 16,
})``;

export const StyledFormButton = styled(Button)`
  flex: 1;
  margin: 0;
`;

export const StyledFormContainer = styled(Box).attrs({
  flow: 24,
  mt: '11px',
})``;

export const StyledLabelText = styled(Text).attrs({
  size: 'normal',
  mb: '8px',
  color: 'primaryText',
})``;

export const StyledTierSelect = styled(Select)`
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 5px;
`;

export const StyledCheckbox = styled(Checkbox)`
  padding: 0;
  margin-left: -4px;
  margin-bottom: 8px;
`;

export const StyledFieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`;
